(function () {
    function getInputFromLabel(label) {
      const inputId = label.getAttribute("for");
      if (!inputId) return null;
      const input = document.getElementById(inputId);
      return input instanceof HTMLInputElement ? input : null;
    }
  
    function setOptionInfoValue(variantPicker, optionPosition, value) {
      if (!optionPosition || !value) return;
      const optionInfoValue = variantPicker.querySelector(
        '.variant-picker__option-info span[data-option-position="' + optionPosition + '"]'
      );
      if (optionInfoValue) {
        optionInfoValue.textContent = value;
      }
    }
  
    function restoreSelectedValue(variantPicker, optionPosition) {
      if (!optionPosition) return;
      const selectedInput = variantPicker.querySelector(
        'input[data-option-position="' + optionPosition + '"]:checked'
      );
      if (!(selectedInput instanceof HTMLInputElement)) return;
  
      const selectedLabel = variantPicker.querySelector('label[for="' + selectedInput.id + '"]');
      const selectedText = selectedLabel?.textContent?.trim();
      if (!selectedText) return;
  
      setOptionInfoValue(variantPicker, optionPosition, selectedText);
    }
  
    document.addEventListener("pointerover", function (event) {
      const label = event.target instanceof Element ? event.target.closest("label.block-swatch[for]") : null;
      if (!label) return;
  
      const variantPicker = label.closest("variant-picker");
      if (!variantPicker) return;
  
      const input = getInputFromLabel(label);
      if (!input || input.disabled) return;
  
      const hoveredText = label.textContent?.trim();
      if (!hoveredText) return;
  
      setOptionInfoValue(variantPicker, input.dataset.optionPosition, hoveredText);
    });
  
    document.addEventListener("pointerout", function (event) {
      const label = event.target instanceof Element ? event.target.closest("label.block-swatch[for]") : null;
      if (!label) return;
  
      const nextTarget = event.relatedTarget;
      if (nextTarget instanceof Node && label.contains(nextTarget)) return;
  
      const variantPicker = label.closest("variant-picker");
      if (!variantPicker) return;
  
      const input = getInputFromLabel(label);
      if (!input) return;
  
      restoreSelectedValue(variantPicker, input.dataset.optionPosition);
    });
  })();
  